import { SvgIconProps } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * This SVG is used to show delete icon
 * @param props - SvgIconProps
 * @example - <CcfDeleteIcon />
 * @returns delete icon
 */
export function CcfDeleteIcon(props: SvgIconProps) {
  return (
    <DeleteIcon {...props} />
  );
}

export default CcfDeleteIcon;
